/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/_app'
import { Route as PortalRouteImport } from './routes/_portal'
import { Route as MeasureRouteImport } from './routes/measure'
import { Route as PortalPortalRouteImport } from './routes/_portal.portal'
import { Route as AppEntrarRouteImport } from './routes/app.entrar'
import { Route as MeasureSalaRouteImport } from './routes/measure_.sala'
import { Route as PortalEntrarRouteImport } from './routes/portal.entrar'
import { Route as PortalPreRouteImport } from './routes/portal.pre'
import { Route as PortalSalaRouteImport } from './routes/portal.sala'
import { Route as AppAppIndexRouteImport } from './routes/_app.app.index'
import { Route as AppAppAgendaRouteImport } from './routes/_app.app.agenda'
import { Route as AppAppAtendimentoRouteImport } from './routes/_app.app.atendimento'
import { Route as AppAppConfigRouteImport } from './routes/_app.app.config'
import { Route as AppAppDinheiroRouteImport } from './routes/_app.app.dinheiro'
import { Route as AppAppDocumentosRouteImport } from './routes/_app.app.documentos'
import { Route as AppAppPacientesRouteImport } from './routes/_app.app.pacientes'
import { Route as AppAppSolicitacoesRouteImport } from './routes/_app.app.solicitacoes'
import { Route as AppAppTarefasRouteImport } from './routes/_app.app.tarefas'
import { Route as AppAppTelasRouteImport } from './routes/_app.app.telas'
import { Route as AppAppTriagemRouteImport } from './routes/_app.app.triagem'
import { Route as PortalPortalDiarioRouteImport } from './routes/_portal.portal_.diario'
import { Route as PortalPortalPagamentosRouteImport } from './routes/_portal.portal_.pagamentos'
import { Route as PortalPortalPrivacidadeRouteImport } from './routes/_portal.portal_.privacidade'
import { Route as PortalPortalRecursosRouteImport } from './routes/_portal.portal_.recursos'
import { Route as PortalCopiaIdRouteImport } from './routes/portal.copia.$id'
import { Route as AppAppAgendaIndexRouteImport } from './routes/_app.app.agenda.index'
import { Route as AppAppAgendaConfigRouteImport } from './routes/_app.app.agenda.config'
import { Route as AppAppConfigIndexRouteImport } from './routes/_app.app.config.index'
import { Route as AppAppConfigConsultorioRouteImport } from './routes/_app.app.config.consultorio'
import { Route as AppAppConfigEquipeRouteImport } from './routes/_app.app.config.equipe'
import { Route as AppAppConfigPlanoBRouteImport } from './routes/_app.app.config.plano-b'
import { Route as AppAppConfigRecibosRouteImport } from './routes/_app.app.config.recibos'
import { Route as AppAppConfigTermosRouteImport } from './routes/_app.app.config.termos'
import { Route as AppAppConfigTextosRouteImport } from './routes/_app.app.config.textos'
import { Route as AppAppLabChatRouteImport } from './routes/_app.app.lab.chat'
import { Route as AppAppLabLogosRouteImport } from './routes/_app.app.lab.logos'
import { Route as AppAppPIdRouteImport } from './routes/_app.app.p.$id'
import { Route as AppAppSIdRouteImport } from './routes/_app.app.s.$id'
import { Route as AppAppTarefasIndexRouteImport } from './routes/_app.app.tarefas.index'
import { Route as AppAppTarefasBoardIdRouteImport } from './routes/_app.app.tarefas.$boardId'
import { Route as PortalPortalQuestionarioIdRouteImport } from './routes/_portal.portal_.questionario.$id'
import { Route as AppAppPIdIndexRouteImport } from './routes/_app.app.p.$id.index'
import { Route as AppAppPIdAlvosRouteImport } from './routes/_app.app.p.$id.alvos'
import { Route as AppAppPIdMapaRouteImport } from './routes/_app.app.p.$id.mapa'
import { Route as AppAppSId_sessaoRouteImport } from './routes/_app.app.s.$id_._sessao'
import { Route as AppAppSId_sessaoAnaliseRouteImport } from './routes/_app.app.s.$id_._sessao.analise'
import { Route as AppAppSId_sessaoNotaRouteImport } from './routes/_app.app.s.$id_._sessao.nota'
import { Route as AppAppSId_sessaoPreparoRouteImport } from './routes/_app.app.s.$id_._sessao.preparo'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalRoute = PortalRouteImport.update({
  id: '/_portal',
  getParentRoute: () => rootRouteImport,
} as any)
const MeasureRoute = MeasureRouteImport.update({
  id: '/measure',
  path: '/measure',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalPortalRoute = PortalPortalRouteImport.update({
  id: '/portal',
  path: '/portal',
  getParentRoute: () => PortalRoute,
} as any)
const AppEntrarRoute = AppEntrarRouteImport.update({
  id: '/app/entrar',
  path: '/app/entrar',
  getParentRoute: () => rootRouteImport,
} as any)
const MeasureSalaRoute = MeasureSalaRouteImport.update({
  id: '/measure_/sala',
  path: '/measure/sala',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalEntrarRoute = PortalEntrarRouteImport.update({
  id: '/portal/entrar',
  path: '/portal/entrar',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalPreRoute = PortalPreRouteImport.update({
  id: '/portal/pre',
  path: '/portal/pre',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalSalaRoute = PortalSalaRouteImport.update({
  id: '/portal/sala',
  path: '/portal/sala',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAppIndexRoute = AppAppIndexRouteImport.update({
  id: '/app/',
  path: '/app/',
  getParentRoute: () => AppRoute,
} as any)
const AppAppAgendaRoute = AppAppAgendaRouteImport.update({
  id: '/app/agenda',
  path: '/app/agenda',
  getParentRoute: () => AppRoute,
} as any)
const AppAppAtendimentoRoute = AppAppAtendimentoRouteImport.update({
  id: '/app/atendimento',
  path: '/app/atendimento',
  getParentRoute: () => AppRoute,
} as any)
const AppAppConfigRoute = AppAppConfigRouteImport.update({
  id: '/app/config',
  path: '/app/config',
  getParentRoute: () => AppRoute,
} as any)
const AppAppDinheiroRoute = AppAppDinheiroRouteImport.update({
  id: '/app/dinheiro',
  path: '/app/dinheiro',
  getParentRoute: () => AppRoute,
} as any)
const AppAppDocumentosRoute = AppAppDocumentosRouteImport.update({
  id: '/app/documentos',
  path: '/app/documentos',
  getParentRoute: () => AppRoute,
} as any)
const AppAppPacientesRoute = AppAppPacientesRouteImport.update({
  id: '/app/pacientes',
  path: '/app/pacientes',
  getParentRoute: () => AppRoute,
} as any)
const AppAppSolicitacoesRoute = AppAppSolicitacoesRouteImport.update({
  id: '/app/solicitacoes',
  path: '/app/solicitacoes',
  getParentRoute: () => AppRoute,
} as any)
const AppAppTarefasRoute = AppAppTarefasRouteImport.update({
  id: '/app/tarefas',
  path: '/app/tarefas',
  getParentRoute: () => AppRoute,
} as any)
const AppAppTelasRoute = AppAppTelasRouteImport.update({
  id: '/app/telas',
  path: '/app/telas',
  getParentRoute: () => AppRoute,
} as any)
const AppAppTriagemRoute = AppAppTriagemRouteImport.update({
  id: '/app/triagem',
  path: '/app/triagem',
  getParentRoute: () => AppRoute,
} as any)
const PortalPortalDiarioRoute = PortalPortalDiarioRouteImport.update({
  id: '/portal_/diario',
  path: '/portal/diario',
  getParentRoute: () => PortalRoute,
} as any)
const PortalPortalPagamentosRoute = PortalPortalPagamentosRouteImport.update({
  id: '/portal_/pagamentos',
  path: '/portal/pagamentos',
  getParentRoute: () => PortalRoute,
} as any)
const PortalPortalPrivacidadeRoute = PortalPortalPrivacidadeRouteImport.update({
  id: '/portal_/privacidade',
  path: '/portal/privacidade',
  getParentRoute: () => PortalRoute,
} as any)
const PortalPortalRecursosRoute = PortalPortalRecursosRouteImport.update({
  id: '/portal_/recursos',
  path: '/portal/recursos',
  getParentRoute: () => PortalRoute,
} as any)
const PortalCopiaIdRoute = PortalCopiaIdRouteImport.update({
  id: '/portal/copia/$id',
  path: '/portal/copia/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAppAgendaIndexRoute = AppAppAgendaIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAppAgendaRoute,
} as any)
const AppAppAgendaConfigRoute = AppAppAgendaConfigRouteImport.update({
  id: '/config',
  path: '/config',
  getParentRoute: () => AppAppAgendaRoute,
} as any)
const AppAppConfigIndexRoute = AppAppConfigIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAppConfigRoute,
} as any)
const AppAppConfigConsultorioRoute = AppAppConfigConsultorioRouteImport.update({
  id: '/consultorio',
  path: '/consultorio',
  getParentRoute: () => AppAppConfigRoute,
} as any)
const AppAppConfigEquipeRoute = AppAppConfigEquipeRouteImport.update({
  id: '/equipe',
  path: '/equipe',
  getParentRoute: () => AppAppConfigRoute,
} as any)
const AppAppConfigPlanoBRoute = AppAppConfigPlanoBRouteImport.update({
  id: '/plano-b',
  path: '/plano-b',
  getParentRoute: () => AppAppConfigRoute,
} as any)
const AppAppConfigRecibosRoute = AppAppConfigRecibosRouteImport.update({
  id: '/recibos',
  path: '/recibos',
  getParentRoute: () => AppAppConfigRoute,
} as any)
const AppAppConfigTermosRoute = AppAppConfigTermosRouteImport.update({
  id: '/termos',
  path: '/termos',
  getParentRoute: () => AppAppConfigRoute,
} as any)
const AppAppConfigTextosRoute = AppAppConfigTextosRouteImport.update({
  id: '/textos',
  path: '/textos',
  getParentRoute: () => AppAppConfigRoute,
} as any)
const AppAppLabChatRoute = AppAppLabChatRouteImport.update({
  id: '/app/lab/chat',
  path: '/app/lab/chat',
  getParentRoute: () => AppRoute,
} as any)
const AppAppLabLogosRoute = AppAppLabLogosRouteImport.update({
  id: '/app/lab/logos',
  path: '/app/lab/logos',
  getParentRoute: () => AppRoute,
} as any)
const AppAppPIdRoute = AppAppPIdRouteImport.update({
  id: '/app/p/$id',
  path: '/app/p/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppAppSIdRoute = AppAppSIdRouteImport.update({
  id: '/app/s/$id',
  path: '/app/s/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppAppTarefasIndexRoute = AppAppTarefasIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAppTarefasRoute,
} as any)
const AppAppTarefasBoardIdRoute = AppAppTarefasBoardIdRouteImport.update({
  id: '/$boardId',
  path: '/$boardId',
  getParentRoute: () => AppAppTarefasRoute,
} as any)
const PortalPortalQuestionarioIdRoute =
  PortalPortalQuestionarioIdRouteImport.update({
    id: '/portal_/questionario/$id',
    path: '/portal/questionario/$id',
    getParentRoute: () => PortalRoute,
  } as any)
const AppAppPIdIndexRoute = AppAppPIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAppPIdRoute,
} as any)
const AppAppPIdAlvosRoute = AppAppPIdAlvosRouteImport.update({
  id: '/alvos',
  path: '/alvos',
  getParentRoute: () => AppAppPIdRoute,
} as any)
const AppAppPIdMapaRoute = AppAppPIdMapaRouteImport.update({
  id: '/mapa',
  path: '/mapa',
  getParentRoute: () => AppAppPIdRoute,
} as any)
const AppAppSId_sessaoRoute = AppAppSId_sessaoRouteImport.update({
  id: '/app/s/$id_/_sessao',
  path: '/app/s/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppAppSId_sessaoAnaliseRoute = AppAppSId_sessaoAnaliseRouteImport.update({
  id: '/analise',
  path: '/analise',
  getParentRoute: () => AppAppSId_sessaoRoute,
} as any)
const AppAppSId_sessaoNotaRoute = AppAppSId_sessaoNotaRouteImport.update({
  id: '/nota',
  path: '/nota',
  getParentRoute: () => AppAppSId_sessaoRoute,
} as any)
const AppAppSId_sessaoPreparoRoute = AppAppSId_sessaoPreparoRouteImport.update({
  id: '/preparo',
  path: '/preparo',
  getParentRoute: () => AppAppSId_sessaoRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/measure': typeof MeasureRoute
  '/portal': typeof PortalPortalRoute
  '/app/entrar': typeof AppEntrarRoute
  '/measure/sala': typeof MeasureSalaRoute
  '/portal/entrar': typeof PortalEntrarRoute
  '/portal/pre': typeof PortalPreRoute
  '/portal/sala': typeof PortalSalaRoute
  '/app/agenda': typeof AppAppAgendaRouteWithChildren
  '/app/atendimento': typeof AppAppAtendimentoRoute
  '/app/config': typeof AppAppConfigRouteWithChildren
  '/app/dinheiro': typeof AppAppDinheiroRoute
  '/app/documentos': typeof AppAppDocumentosRoute
  '/app/pacientes': typeof AppAppPacientesRoute
  '/app/solicitacoes': typeof AppAppSolicitacoesRoute
  '/app/tarefas': typeof AppAppTarefasRouteWithChildren
  '/app/telas': typeof AppAppTelasRoute
  '/app/triagem': typeof AppAppTriagemRoute
  '/portal/diario': typeof PortalPortalDiarioRoute
  '/portal/pagamentos': typeof PortalPortalPagamentosRoute
  '/portal/privacidade': typeof PortalPortalPrivacidadeRoute
  '/portal/recursos': typeof PortalPortalRecursosRoute
  '/portal/copia/$id': typeof PortalCopiaIdRoute
  '/app/': typeof AppAppIndexRoute
  '/app/agenda/config': typeof AppAppAgendaConfigRoute
  '/app/config/consultorio': typeof AppAppConfigConsultorioRoute
  '/app/config/equipe': typeof AppAppConfigEquipeRoute
  '/app/config/plano-b': typeof AppAppConfigPlanoBRoute
  '/app/config/recibos': typeof AppAppConfigRecibosRoute
  '/app/config/termos': typeof AppAppConfigTermosRoute
  '/app/config/textos': typeof AppAppConfigTextosRoute
  '/app/lab/chat': typeof AppAppLabChatRoute
  '/app/lab/logos': typeof AppAppLabLogosRoute
  '/app/p/$id': typeof AppAppPIdRouteWithChildren
  '/app/s/$id': typeof AppAppSIdRoute
  '/app/tarefas/$boardId': typeof AppAppTarefasBoardIdRoute
  '/portal/questionario/$id': typeof PortalPortalQuestionarioIdRoute
  '/app/agenda/': typeof AppAppAgendaIndexRoute
  '/app/config/': typeof AppAppConfigIndexRoute
  '/app/tarefas/': typeof AppAppTarefasIndexRoute
  '/app/p/$id/alvos': typeof AppAppPIdAlvosRoute
  '/app/p/$id/mapa': typeof AppAppPIdMapaRoute
  '/app/p/$id/': typeof AppAppPIdIndexRoute
  '/app/s/$id/analise': typeof AppAppSId_sessaoAnaliseRoute
  '/app/s/$id/nota': typeof AppAppSId_sessaoNotaRoute
  '/app/s/$id/preparo': typeof AppAppSId_sessaoPreparoRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/measure': typeof MeasureRoute
  '/portal': typeof PortalPortalRoute
  '/app/entrar': typeof AppEntrarRoute
  '/measure/sala': typeof MeasureSalaRoute
  '/portal/entrar': typeof PortalEntrarRoute
  '/portal/pre': typeof PortalPreRoute
  '/portal/sala': typeof PortalSalaRoute
  '/app/atendimento': typeof AppAppAtendimentoRoute
  '/app/dinheiro': typeof AppAppDinheiroRoute
  '/app/documentos': typeof AppAppDocumentosRoute
  '/app/pacientes': typeof AppAppPacientesRoute
  '/app/solicitacoes': typeof AppAppSolicitacoesRoute
  '/app/telas': typeof AppAppTelasRoute
  '/app/triagem': typeof AppAppTriagemRoute
  '/portal/diario': typeof PortalPortalDiarioRoute
  '/portal/pagamentos': typeof PortalPortalPagamentosRoute
  '/portal/privacidade': typeof PortalPortalPrivacidadeRoute
  '/portal/recursos': typeof PortalPortalRecursosRoute
  '/portal/copia/$id': typeof PortalCopiaIdRoute
  '/app': typeof AppAppIndexRoute
  '/app/agenda/config': typeof AppAppAgendaConfigRoute
  '/app/config/consultorio': typeof AppAppConfigConsultorioRoute
  '/app/config/equipe': typeof AppAppConfigEquipeRoute
  '/app/config/plano-b': typeof AppAppConfigPlanoBRoute
  '/app/config/recibos': typeof AppAppConfigRecibosRoute
  '/app/config/termos': typeof AppAppConfigTermosRoute
  '/app/config/textos': typeof AppAppConfigTextosRoute
  '/app/lab/chat': typeof AppAppLabChatRoute
  '/app/lab/logos': typeof AppAppLabLogosRoute
  '/app/s/$id': typeof AppAppSIdRoute
  '/app/tarefas/$boardId': typeof AppAppTarefasBoardIdRoute
  '/portal/questionario/$id': typeof PortalPortalQuestionarioIdRoute
  '/app/agenda': typeof AppAppAgendaIndexRoute
  '/app/config': typeof AppAppConfigIndexRoute
  '/app/tarefas': typeof AppAppTarefasIndexRoute
  '/app/p/$id/alvos': typeof AppAppPIdAlvosRoute
  '/app/p/$id/mapa': typeof AppAppPIdMapaRoute
  '/app/p/$id': typeof AppAppPIdIndexRoute
  '/app/s/$id/analise': typeof AppAppSId_sessaoAnaliseRoute
  '/app/s/$id/nota': typeof AppAppSId_sessaoNotaRoute
  '/app/s/$id/preparo': typeof AppAppSId_sessaoPreparoRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/_portal': typeof PortalRouteWithChildren
  '/measure': typeof MeasureRoute
  '/_portal/portal': typeof PortalPortalRoute
  '/app/entrar': typeof AppEntrarRoute
  '/measure_/sala': typeof MeasureSalaRoute
  '/portal/entrar': typeof PortalEntrarRoute
  '/portal/pre': typeof PortalPreRoute
  '/portal/sala': typeof PortalSalaRoute
  '/_app/app/agenda': typeof AppAppAgendaRouteWithChildren
  '/_app/app/atendimento': typeof AppAppAtendimentoRoute
  '/_app/app/config': typeof AppAppConfigRouteWithChildren
  '/_app/app/dinheiro': typeof AppAppDinheiroRoute
  '/_app/app/documentos': typeof AppAppDocumentosRoute
  '/_app/app/pacientes': typeof AppAppPacientesRoute
  '/_app/app/solicitacoes': typeof AppAppSolicitacoesRoute
  '/_app/app/tarefas': typeof AppAppTarefasRouteWithChildren
  '/_app/app/telas': typeof AppAppTelasRoute
  '/_app/app/triagem': typeof AppAppTriagemRoute
  '/_portal/portal_/diario': typeof PortalPortalDiarioRoute
  '/_portal/portal_/pagamentos': typeof PortalPortalPagamentosRoute
  '/_portal/portal_/privacidade': typeof PortalPortalPrivacidadeRoute
  '/_portal/portal_/recursos': typeof PortalPortalRecursosRoute
  '/portal/copia/$id': typeof PortalCopiaIdRoute
  '/_app/app/': typeof AppAppIndexRoute
  '/_app/app/agenda/config': typeof AppAppAgendaConfigRoute
  '/_app/app/config/consultorio': typeof AppAppConfigConsultorioRoute
  '/_app/app/config/equipe': typeof AppAppConfigEquipeRoute
  '/_app/app/config/plano-b': typeof AppAppConfigPlanoBRoute
  '/_app/app/config/recibos': typeof AppAppConfigRecibosRoute
  '/_app/app/config/termos': typeof AppAppConfigTermosRoute
  '/_app/app/config/textos': typeof AppAppConfigTextosRoute
  '/_app/app/lab/chat': typeof AppAppLabChatRoute
  '/_app/app/lab/logos': typeof AppAppLabLogosRoute
  '/_app/app/p/$id': typeof AppAppPIdRouteWithChildren
  '/_app/app/s/$id': typeof AppAppSIdRoute
  '/_app/app/tarefas/$boardId': typeof AppAppTarefasBoardIdRoute
  '/_portal/portal_/questionario/$id': typeof PortalPortalQuestionarioIdRoute
  '/_app/app/agenda/': typeof AppAppAgendaIndexRoute
  '/_app/app/config/': typeof AppAppConfigIndexRoute
  '/_app/app/tarefas/': typeof AppAppTarefasIndexRoute
  '/_app/app/p/$id/alvos': typeof AppAppPIdAlvosRoute
  '/_app/app/p/$id/mapa': typeof AppAppPIdMapaRoute
  '/_app/app/s/$id_/_sessao': typeof AppAppSId_sessaoRouteWithChildren
  '/_app/app/p/$id/': typeof AppAppPIdIndexRoute
  '/_app/app/s/$id_/_sessao/analise': typeof AppAppSId_sessaoAnaliseRoute
  '/_app/app/s/$id_/_sessao/nota': typeof AppAppSId_sessaoNotaRoute
  '/_app/app/s/$id_/_sessao/preparo': typeof AppAppSId_sessaoPreparoRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/measure'
    | '/portal'
    | '/app/entrar'
    | '/measure/sala'
    | '/portal/entrar'
    | '/portal/pre'
    | '/portal/sala'
    | '/app/agenda'
    | '/app/atendimento'
    | '/app/config'
    | '/app/dinheiro'
    | '/app/documentos'
    | '/app/pacientes'
    | '/app/solicitacoes'
    | '/app/tarefas'
    | '/app/telas'
    | '/app/triagem'
    | '/portal/diario'
    | '/portal/pagamentos'
    | '/portal/privacidade'
    | '/portal/recursos'
    | '/portal/copia/$id'
    | '/app/'
    | '/app/agenda/config'
    | '/app/config/consultorio'
    | '/app/config/equipe'
    | '/app/config/plano-b'
    | '/app/config/recibos'
    | '/app/config/termos'
    | '/app/config/textos'
    | '/app/lab/chat'
    | '/app/lab/logos'
    | '/app/p/$id'
    | '/app/s/$id'
    | '/app/tarefas/$boardId'
    | '/portal/questionario/$id'
    | '/app/agenda/'
    | '/app/config/'
    | '/app/tarefas/'
    | '/app/p/$id/alvos'
    | '/app/p/$id/mapa'
    | '/app/p/$id/'
    | '/app/s/$id/analise'
    | '/app/s/$id/nota'
    | '/app/s/$id/preparo'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/measure'
    | '/portal'
    | '/app/entrar'
    | '/measure/sala'
    | '/portal/entrar'
    | '/portal/pre'
    | '/portal/sala'
    | '/app/atendimento'
    | '/app/dinheiro'
    | '/app/documentos'
    | '/app/pacientes'
    | '/app/solicitacoes'
    | '/app/telas'
    | '/app/triagem'
    | '/portal/diario'
    | '/portal/pagamentos'
    | '/portal/privacidade'
    | '/portal/recursos'
    | '/portal/copia/$id'
    | '/app'
    | '/app/agenda/config'
    | '/app/config/consultorio'
    | '/app/config/equipe'
    | '/app/config/plano-b'
    | '/app/config/recibos'
    | '/app/config/termos'
    | '/app/config/textos'
    | '/app/lab/chat'
    | '/app/lab/logos'
    | '/app/s/$id'
    | '/app/tarefas/$boardId'
    | '/portal/questionario/$id'
    | '/app/agenda'
    | '/app/config'
    | '/app/tarefas'
    | '/app/p/$id/alvos'
    | '/app/p/$id/mapa'
    | '/app/p/$id'
    | '/app/s/$id/analise'
    | '/app/s/$id/nota'
    | '/app/s/$id/preparo'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/_portal'
    | '/measure'
    | '/_portal/portal'
    | '/app/entrar'
    | '/measure_/sala'
    | '/portal/entrar'
    | '/portal/pre'
    | '/portal/sala'
    | '/_app/app/agenda'
    | '/_app/app/atendimento'
    | '/_app/app/config'
    | '/_app/app/dinheiro'
    | '/_app/app/documentos'
    | '/_app/app/pacientes'
    | '/_app/app/solicitacoes'
    | '/_app/app/tarefas'
    | '/_app/app/telas'
    | '/_app/app/triagem'
    | '/_portal/portal_/diario'
    | '/_portal/portal_/pagamentos'
    | '/_portal/portal_/privacidade'
    | '/_portal/portal_/recursos'
    | '/portal/copia/$id'
    | '/_app/app/'
    | '/_app/app/agenda/config'
    | '/_app/app/config/consultorio'
    | '/_app/app/config/equipe'
    | '/_app/app/config/plano-b'
    | '/_app/app/config/recibos'
    | '/_app/app/config/termos'
    | '/_app/app/config/textos'
    | '/_app/app/lab/chat'
    | '/_app/app/lab/logos'
    | '/_app/app/p/$id'
    | '/_app/app/s/$id'
    | '/_app/app/tarefas/$boardId'
    | '/_portal/portal_/questionario/$id'
    | '/_app/app/agenda/'
    | '/_app/app/config/'
    | '/_app/app/tarefas/'
    | '/_app/app/p/$id/alvos'
    | '/_app/app/p/$id/mapa'
    | '/_app/app/s/$id_/_sessao'
    | '/_app/app/p/$id/'
    | '/_app/app/s/$id_/_sessao/analise'
    | '/_app/app/s/$id_/_sessao/nota'
    | '/_app/app/s/$id_/_sessao/preparo'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  PortalRoute: typeof PortalRouteWithChildren
  MeasureRoute: typeof MeasureRoute
  AppEntrarRoute: typeof AppEntrarRoute
  MeasureSalaRoute: typeof MeasureSalaRoute
  PortalEntrarRoute: typeof PortalEntrarRoute
  PortalPreRoute: typeof PortalPreRoute
  PortalSalaRoute: typeof PortalSalaRoute
  PortalCopiaIdRoute: typeof PortalCopiaIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_portal': {
      id: '/_portal'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PortalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/measure': {
      id: '/measure'
      path: '/measure'
      fullPath: '/measure'
      preLoaderRoute: typeof MeasureRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_portal/portal': {
      id: '/_portal/portal'
      path: '/portal'
      fullPath: '/portal'
      preLoaderRoute: typeof PortalPortalRouteImport
      parentRoute: typeof PortalRoute
    }
    '/app/entrar': {
      id: '/app/entrar'
      path: '/app/entrar'
      fullPath: '/app/entrar'
      preLoaderRoute: typeof AppEntrarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/measure_/sala': {
      id: '/measure_/sala'
      path: '/measure/sala'
      fullPath: '/measure/sala'
      preLoaderRoute: typeof MeasureSalaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/entrar': {
      id: '/portal/entrar'
      path: '/portal/entrar'
      fullPath: '/portal/entrar'
      preLoaderRoute: typeof PortalEntrarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/pre': {
      id: '/portal/pre'
      path: '/portal/pre'
      fullPath: '/portal/pre'
      preLoaderRoute: typeof PortalPreRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/sala': {
      id: '/portal/sala'
      path: '/portal/sala'
      fullPath: '/portal/sala'
      preLoaderRoute: typeof PortalSalaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/app/': {
      id: '/_app/app/'
      path: '/app'
      fullPath: '/app/'
      preLoaderRoute: typeof AppAppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/app/agenda': {
      id: '/_app/app/agenda'
      path: '/app/agenda'
      fullPath: '/app/agenda'
      preLoaderRoute: typeof AppAppAgendaRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/app/atendimento': {
      id: '/_app/app/atendimento'
      path: '/app/atendimento'
      fullPath: '/app/atendimento'
      preLoaderRoute: typeof AppAppAtendimentoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/app/config': {
      id: '/_app/app/config'
      path: '/app/config'
      fullPath: '/app/config'
      preLoaderRoute: typeof AppAppConfigRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/app/dinheiro': {
      id: '/_app/app/dinheiro'
      path: '/app/dinheiro'
      fullPath: '/app/dinheiro'
      preLoaderRoute: typeof AppAppDinheiroRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/app/documentos': {
      id: '/_app/app/documentos'
      path: '/app/documentos'
      fullPath: '/app/documentos'
      preLoaderRoute: typeof AppAppDocumentosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/app/pacientes': {
      id: '/_app/app/pacientes'
      path: '/app/pacientes'
      fullPath: '/app/pacientes'
      preLoaderRoute: typeof AppAppPacientesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/app/solicitacoes': {
      id: '/_app/app/solicitacoes'
      path: '/app/solicitacoes'
      fullPath: '/app/solicitacoes'
      preLoaderRoute: typeof AppAppSolicitacoesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/app/tarefas': {
      id: '/_app/app/tarefas'
      path: '/app/tarefas'
      fullPath: '/app/tarefas'
      preLoaderRoute: typeof AppAppTarefasRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/app/telas': {
      id: '/_app/app/telas'
      path: '/app/telas'
      fullPath: '/app/telas'
      preLoaderRoute: typeof AppAppTelasRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/app/triagem': {
      id: '/_app/app/triagem'
      path: '/app/triagem'
      fullPath: '/app/triagem'
      preLoaderRoute: typeof AppAppTriagemRouteImport
      parentRoute: typeof AppRoute
    }
    '/_portal/portal_/diario': {
      id: '/_portal/portal_/diario'
      path: '/portal/diario'
      fullPath: '/portal/diario'
      preLoaderRoute: typeof PortalPortalDiarioRouteImport
      parentRoute: typeof PortalRoute
    }
    '/_portal/portal_/pagamentos': {
      id: '/_portal/portal_/pagamentos'
      path: '/portal/pagamentos'
      fullPath: '/portal/pagamentos'
      preLoaderRoute: typeof PortalPortalPagamentosRouteImport
      parentRoute: typeof PortalRoute
    }
    '/_portal/portal_/privacidade': {
      id: '/_portal/portal_/privacidade'
      path: '/portal/privacidade'
      fullPath: '/portal/privacidade'
      preLoaderRoute: typeof PortalPortalPrivacidadeRouteImport
      parentRoute: typeof PortalRoute
    }
    '/_portal/portal_/recursos': {
      id: '/_portal/portal_/recursos'
      path: '/portal/recursos'
      fullPath: '/portal/recursos'
      preLoaderRoute: typeof PortalPortalRecursosRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/copia/$id': {
      id: '/portal/copia/$id'
      path: '/portal/copia/$id'
      fullPath: '/portal/copia/$id'
      preLoaderRoute: typeof PortalCopiaIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/app/agenda/': {
      id: '/_app/app/agenda/'
      path: '/'
      fullPath: '/app/agenda/'
      preLoaderRoute: typeof AppAppAgendaIndexRouteImport
      parentRoute: typeof AppAppAgendaRoute
    }
    '/_app/app/agenda/config': {
      id: '/_app/app/agenda/config'
      path: '/config'
      fullPath: '/app/agenda/config'
      preLoaderRoute: typeof AppAppAgendaConfigRouteImport
      parentRoute: typeof AppAppAgendaRoute
    }
    '/_app/app/config/': {
      id: '/_app/app/config/'
      path: '/'
      fullPath: '/app/config/'
      preLoaderRoute: typeof AppAppConfigIndexRouteImport
      parentRoute: typeof AppAppConfigRoute
    }
    '/_app/app/config/consultorio': {
      id: '/_app/app/config/consultorio'
      path: '/consultorio'
      fullPath: '/app/config/consultorio'
      preLoaderRoute: typeof AppAppConfigConsultorioRouteImport
      parentRoute: typeof AppAppConfigRoute
    }
    '/_app/app/config/equipe': {
      id: '/_app/app/config/equipe'
      path: '/equipe'
      fullPath: '/app/config/equipe'
      preLoaderRoute: typeof AppAppConfigEquipeRouteImport
      parentRoute: typeof AppAppConfigRoute
    }
    '/_app/app/config/plano-b': {
      id: '/_app/app/config/plano-b'
      path: '/plano-b'
      fullPath: '/app/config/plano-b'
      preLoaderRoute: typeof AppAppConfigPlanoBRouteImport
      parentRoute: typeof AppAppConfigRoute
    }
    '/_app/app/config/recibos': {
      id: '/_app/app/config/recibos'
      path: '/recibos'
      fullPath: '/app/config/recibos'
      preLoaderRoute: typeof AppAppConfigRecibosRouteImport
      parentRoute: typeof AppAppConfigRoute
    }
    '/_app/app/config/termos': {
      id: '/_app/app/config/termos'
      path: '/termos'
      fullPath: '/app/config/termos'
      preLoaderRoute: typeof AppAppConfigTermosRouteImport
      parentRoute: typeof AppAppConfigRoute
    }
    '/_app/app/config/textos': {
      id: '/_app/app/config/textos'
      path: '/textos'
      fullPath: '/app/config/textos'
      preLoaderRoute: typeof AppAppConfigTextosRouteImport
      parentRoute: typeof AppAppConfigRoute
    }
    '/_app/app/lab/chat': {
      id: '/_app/app/lab/chat'
      path: '/app/lab/chat'
      fullPath: '/app/lab/chat'
      preLoaderRoute: typeof AppAppLabChatRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/app/lab/logos': {
      id: '/_app/app/lab/logos'
      path: '/app/lab/logos'
      fullPath: '/app/lab/logos'
      preLoaderRoute: typeof AppAppLabLogosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/app/p/$id': {
      id: '/_app/app/p/$id'
      path: '/app/p/$id'
      fullPath: '/app/p/$id'
      preLoaderRoute: typeof AppAppPIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/app/s/$id': {
      id: '/_app/app/s/$id'
      path: '/app/s/$id'
      fullPath: '/app/s/$id'
      preLoaderRoute: typeof AppAppSIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/app/tarefas/': {
      id: '/_app/app/tarefas/'
      path: '/'
      fullPath: '/app/tarefas/'
      preLoaderRoute: typeof AppAppTarefasIndexRouteImport
      parentRoute: typeof AppAppTarefasRoute
    }
    '/_app/app/tarefas/$boardId': {
      id: '/_app/app/tarefas/$boardId'
      path: '/$boardId'
      fullPath: '/app/tarefas/$boardId'
      preLoaderRoute: typeof AppAppTarefasBoardIdRouteImport
      parentRoute: typeof AppAppTarefasRoute
    }
    '/_portal/portal_/questionario/$id': {
      id: '/_portal/portal_/questionario/$id'
      path: '/portal/questionario/$id'
      fullPath: '/portal/questionario/$id'
      preLoaderRoute: typeof PortalPortalQuestionarioIdRouteImport
      parentRoute: typeof PortalRoute
    }
    '/_app/app/p/$id/': {
      id: '/_app/app/p/$id/'
      path: '/'
      fullPath: '/app/p/$id/'
      preLoaderRoute: typeof AppAppPIdIndexRouteImport
      parentRoute: typeof AppAppPIdRoute
    }
    '/_app/app/p/$id/alvos': {
      id: '/_app/app/p/$id/alvos'
      path: '/alvos'
      fullPath: '/app/p/$id/alvos'
      preLoaderRoute: typeof AppAppPIdAlvosRouteImport
      parentRoute: typeof AppAppPIdRoute
    }
    '/_app/app/p/$id/mapa': {
      id: '/_app/app/p/$id/mapa'
      path: '/mapa'
      fullPath: '/app/p/$id/mapa'
      preLoaderRoute: typeof AppAppPIdMapaRouteImport
      parentRoute: typeof AppAppPIdRoute
    }
    '/_app/app/s/$id_/_sessao': {
      id: '/_app/app/s/$id_/_sessao'
      path: '/app/s/$id'
      fullPath: '/app/s/$id'
      preLoaderRoute: typeof AppAppSId_sessaoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/app/s/$id_/_sessao/analise': {
      id: '/_app/app/s/$id_/_sessao/analise'
      path: '/analise'
      fullPath: '/app/s/$id/analise'
      preLoaderRoute: typeof AppAppSId_sessaoAnaliseRouteImport
      parentRoute: typeof AppAppSId_sessaoRoute
    }
    '/_app/app/s/$id_/_sessao/nota': {
      id: '/_app/app/s/$id_/_sessao/nota'
      path: '/nota'
      fullPath: '/app/s/$id/nota'
      preLoaderRoute: typeof AppAppSId_sessaoNotaRouteImport
      parentRoute: typeof AppAppSId_sessaoRoute
    }
    '/_app/app/s/$id_/_sessao/preparo': {
      id: '/_app/app/s/$id_/_sessao/preparo'
      path: '/preparo'
      fullPath: '/app/s/$id/preparo'
      preLoaderRoute: typeof AppAppSId_sessaoPreparoRouteImport
      parentRoute: typeof AppAppSId_sessaoRoute
    }
  }
}

interface AppAppAgendaRouteChildren {
  AppAppAgendaConfigRoute: typeof AppAppAgendaConfigRoute
  AppAppAgendaIndexRoute: typeof AppAppAgendaIndexRoute
}

const AppAppAgendaRouteChildren: AppAppAgendaRouteChildren = {
  AppAppAgendaConfigRoute: AppAppAgendaConfigRoute,
  AppAppAgendaIndexRoute: AppAppAgendaIndexRoute,
}

const AppAppAgendaRouteWithChildren = AppAppAgendaRoute._addFileChildren(
  AppAppAgendaRouteChildren,
)

interface AppAppConfigRouteChildren {
  AppAppConfigConsultorioRoute: typeof AppAppConfigConsultorioRoute
  AppAppConfigEquipeRoute: typeof AppAppConfigEquipeRoute
  AppAppConfigPlanoBRoute: typeof AppAppConfigPlanoBRoute
  AppAppConfigRecibosRoute: typeof AppAppConfigRecibosRoute
  AppAppConfigTermosRoute: typeof AppAppConfigTermosRoute
  AppAppConfigTextosRoute: typeof AppAppConfigTextosRoute
  AppAppConfigIndexRoute: typeof AppAppConfigIndexRoute
}

const AppAppConfigRouteChildren: AppAppConfigRouteChildren = {
  AppAppConfigConsultorioRoute: AppAppConfigConsultorioRoute,
  AppAppConfigEquipeRoute: AppAppConfigEquipeRoute,
  AppAppConfigPlanoBRoute: AppAppConfigPlanoBRoute,
  AppAppConfigRecibosRoute: AppAppConfigRecibosRoute,
  AppAppConfigTermosRoute: AppAppConfigTermosRoute,
  AppAppConfigTextosRoute: AppAppConfigTextosRoute,
  AppAppConfigIndexRoute: AppAppConfigIndexRoute,
}

const AppAppConfigRouteWithChildren = AppAppConfigRoute._addFileChildren(
  AppAppConfigRouteChildren,
)

interface AppAppTarefasRouteChildren {
  AppAppTarefasBoardIdRoute: typeof AppAppTarefasBoardIdRoute
  AppAppTarefasIndexRoute: typeof AppAppTarefasIndexRoute
}

const AppAppTarefasRouteChildren: AppAppTarefasRouteChildren = {
  AppAppTarefasBoardIdRoute: AppAppTarefasBoardIdRoute,
  AppAppTarefasIndexRoute: AppAppTarefasIndexRoute,
}

const AppAppTarefasRouteWithChildren = AppAppTarefasRoute._addFileChildren(
  AppAppTarefasRouteChildren,
)

interface AppAppPIdRouteChildren {
  AppAppPIdAlvosRoute: typeof AppAppPIdAlvosRoute
  AppAppPIdMapaRoute: typeof AppAppPIdMapaRoute
  AppAppPIdIndexRoute: typeof AppAppPIdIndexRoute
}

const AppAppPIdRouteChildren: AppAppPIdRouteChildren = {
  AppAppPIdAlvosRoute: AppAppPIdAlvosRoute,
  AppAppPIdMapaRoute: AppAppPIdMapaRoute,
  AppAppPIdIndexRoute: AppAppPIdIndexRoute,
}

const AppAppPIdRouteWithChildren = AppAppPIdRoute._addFileChildren(
  AppAppPIdRouteChildren,
)

interface AppAppSId_sessaoRouteChildren {
  AppAppSId_sessaoAnaliseRoute: typeof AppAppSId_sessaoAnaliseRoute
  AppAppSId_sessaoNotaRoute: typeof AppAppSId_sessaoNotaRoute
  AppAppSId_sessaoPreparoRoute: typeof AppAppSId_sessaoPreparoRoute
}

const AppAppSId_sessaoRouteChildren: AppAppSId_sessaoRouteChildren = {
  AppAppSId_sessaoAnaliseRoute: AppAppSId_sessaoAnaliseRoute,
  AppAppSId_sessaoNotaRoute: AppAppSId_sessaoNotaRoute,
  AppAppSId_sessaoPreparoRoute: AppAppSId_sessaoPreparoRoute,
}

const AppAppSId_sessaoRouteWithChildren =
  AppAppSId_sessaoRoute._addFileChildren(AppAppSId_sessaoRouteChildren)

interface AppRouteChildren {
  AppAppAgendaRoute: typeof AppAppAgendaRouteWithChildren
  AppAppAtendimentoRoute: typeof AppAppAtendimentoRoute
  AppAppConfigRoute: typeof AppAppConfigRouteWithChildren
  AppAppDinheiroRoute: typeof AppAppDinheiroRoute
  AppAppDocumentosRoute: typeof AppAppDocumentosRoute
  AppAppPacientesRoute: typeof AppAppPacientesRoute
  AppAppSolicitacoesRoute: typeof AppAppSolicitacoesRoute
  AppAppTarefasRoute: typeof AppAppTarefasRouteWithChildren
  AppAppTelasRoute: typeof AppAppTelasRoute
  AppAppTriagemRoute: typeof AppAppTriagemRoute
  AppAppIndexRoute: typeof AppAppIndexRoute
  AppAppLabChatRoute: typeof AppAppLabChatRoute
  AppAppLabLogosRoute: typeof AppAppLabLogosRoute
  AppAppPIdRoute: typeof AppAppPIdRouteWithChildren
  AppAppSIdRoute: typeof AppAppSIdRoute
  AppAppSId_sessaoRoute: typeof AppAppSId_sessaoRouteWithChildren
}

const AppRouteChildren: AppRouteChildren = {
  AppAppAgendaRoute: AppAppAgendaRouteWithChildren,
  AppAppAtendimentoRoute: AppAppAtendimentoRoute,
  AppAppConfigRoute: AppAppConfigRouteWithChildren,
  AppAppDinheiroRoute: AppAppDinheiroRoute,
  AppAppDocumentosRoute: AppAppDocumentosRoute,
  AppAppPacientesRoute: AppAppPacientesRoute,
  AppAppSolicitacoesRoute: AppAppSolicitacoesRoute,
  AppAppTarefasRoute: AppAppTarefasRouteWithChildren,
  AppAppTelasRoute: AppAppTelasRoute,
  AppAppTriagemRoute: AppAppTriagemRoute,
  AppAppIndexRoute: AppAppIndexRoute,
  AppAppLabChatRoute: AppAppLabChatRoute,
  AppAppLabLogosRoute: AppAppLabLogosRoute,
  AppAppPIdRoute: AppAppPIdRouteWithChildren,
  AppAppSIdRoute: AppAppSIdRoute,
  AppAppSId_sessaoRoute: AppAppSId_sessaoRouteWithChildren,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface PortalRouteChildren {
  PortalPortalRoute: typeof PortalPortalRoute
  PortalPortalDiarioRoute: typeof PortalPortalDiarioRoute
  PortalPortalPagamentosRoute: typeof PortalPortalPagamentosRoute
  PortalPortalPrivacidadeRoute: typeof PortalPortalPrivacidadeRoute
  PortalPortalRecursosRoute: typeof PortalPortalRecursosRoute
  PortalPortalQuestionarioIdRoute: typeof PortalPortalQuestionarioIdRoute
}

const PortalRouteChildren: PortalRouteChildren = {
  PortalPortalRoute: PortalPortalRoute,
  PortalPortalDiarioRoute: PortalPortalDiarioRoute,
  PortalPortalPagamentosRoute: PortalPortalPagamentosRoute,
  PortalPortalPrivacidadeRoute: PortalPortalPrivacidadeRoute,
  PortalPortalRecursosRoute: PortalPortalRecursosRoute,
  PortalPortalQuestionarioIdRoute: PortalPortalQuestionarioIdRoute,
}

const PortalRouteWithChildren =
  PortalRoute._addFileChildren(PortalRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  PortalRoute: PortalRouteWithChildren,
  MeasureRoute: MeasureRoute,
  AppEntrarRoute: AppEntrarRoute,
  MeasureSalaRoute: MeasureSalaRoute,
  PortalEntrarRoute: PortalEntrarRoute,
  PortalPreRoute: PortalPreRoute,
  PortalSalaRoute: PortalSalaRoute,
  PortalCopiaIdRoute: PortalCopiaIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
